export default {
  data() {
    return {
      uploads: {
        sortMainColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            key: "title",
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortProjectFiles("title", "ASC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortProjectFiles("title", "DESC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        showAsThirdColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            key: "created_at",
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortProjectFiles("created_at", "ASC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortProjectFiles("created_at", "DESC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
      },
    };
  },
};
